import banking1 from '../assets/images/banking1.png';
import banking2 from '../assets/images/banking2.png';
import banking3 from '../assets/images/banking3.png';
import banking4 from '../assets/images/banking4.png';
import banking5 from '../assets/images/banking5.png';
import banking6 from '../assets/images/banking6.png';
import banking7 from '../assets/images/banking7.png';

export default [
  {
    sn: '01',
    img: banking1
  },
  {
    sn: '02',
    img: banking2
  },
  {
    sn: '03',
    img: banking3
  },
  {
    sn: '04',
    img: banking4
  },
  {
    sn: '05',
    img: banking5
  },
  {
    sn: '06',
    img: banking6
  },
  {
    sn: '07',
    img: banking7
  }
];
